import React from "react";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";

/**
 * USE THIS COMPONENT WHERE YOU NEED TO IMPLEMENT DRAG AND DROP IMPORT CARD TO WRAP YOUR DRAGGABLE CHILDREN (Check out it's props) moveCard function will fire new order of components
 */
function DraggableList(props) {
	return (
		<DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
			{props.children}
		</DndProvider>
	);
}

export default DraggableList;
